import React from "react";
import { Seo } from "../components/Seo";
import { Reveal, SectionHeader } from "../components/site/Reveal";
import { BRAND, POLICIES } from "../lib/content";

export default function About() {
  return (
    <>
      <Seo title="About SPECA Detailing" description="Premium automotive detailing studio in Noble Park, Melbourne. Professionally trained by XEE Detailing. Premium products from GYEON, Koch Chemie and NXTZEN." path="/about" />
      <section className="pt-32 pb-16 md:pt-40">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <SectionHeader overline="About Us" title="Driven by passion. Defined by precision." />
        </div>
      </section>

      <section className="pb-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7 space-y-5 text-gray-300 font-light leading-relaxed text-base md:text-lg">
            <Reveal><p>At SPECA Detailing, we believe every vehicle deserves exceptional care.</p></Reveal>
            <Reveal delay={0.08}><p>Based in {BRAND.location}, SPECA Detailing provides premium automotive detailing, paint correction and ceramic protection services for customers who value quality workmanship and attention to detail.</p></Reveal>
            <Reveal delay={0.16}><p>Professionally trained by XEE Detailing, we combine careful techniques with trusted professional products from brands including <span className="text-white">GYEON</span>, <span className="text-white">Koch Chemie</span> and <span className="text-white">NXTZEN</span>.</p></Reveal>
            <Reveal delay={0.24}><p>Whether maintaining a daily driver or enhancing a performance vehicle, our goal is to deliver a finish that reflects our commitment to precision and quality.</p></Reveal>
          </div>
          <div className="lg:col-span-5">
            <Reveal className="relative">
              <div className="relative aspect-[4/5] overflow-hidden border border-white/10 grain">
                <img src="/images/gyeon-applicator.webp" alt="GYEON ceramic coating applied by SPECA Detailing in Noble Park, Melbourne" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#080808] via-transparent to-transparent" />
              </div>
              <div className="absolute -bottom-6 -left-6 glass-card px-6 py-5 max-w-[300px]">
                <p className="font-display font-black text-lg text-white leading-tight">We use genuine GYEON ceramic coating products.</p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#0A0A0A] border-y border-white/5">
        <div className="max-w-5xl mx-auto px-6 lg:px-8">
          <SectionHeader overline="Policies" title="Our promises & conditions." />
          <ul className="mt-10 space-y-3 text-gray-400 font-light text-sm md:text-base">
            {POLICIES.map((p, i) => (<li key={i} className="flex gap-3"><span className="text-silver">·</span>{p}</li>))}
          </ul>
        </div>
      </section>
    </>
  );
}
